/**
 * @package after-sales
 * @private
 */
Shopware.Component.register(
    'swag-migration-profile-shopware6major-api-credential-form',
    () => import('./api/swag-migration-profile-shopware6-api-credential-form'),
);
